import Campaign from './Campaign';

export default Campaign;
